import { render, staticRenderFns } from "./CriarDiretorioDialog.vue?vue&type=template&id=36f159d0&"
import script from "./CriarDiretorioDialog.vue?vue&type=script&lang=js&"
export * from "./CriarDiretorioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CriarDiretorioDialog.vue"
export default component.exports